import { IPageResponse } from "common/interfaces/IPageResponse";
import { CUSTOMER_APPLICATION_STATUS_MAP, CUSTOMER_APPLICATION_TYPE_MAP, CustomerApplication, CustomerApplicationStatus } from "models/customer-application";
import React from "react";
import Pagination from "rc-pagination";
import { locale } from "../../common/table/paginatorConfig";
import { Spinner } from 'react-bootstrap';
import { CustomerPermission, useAuthContext } from "services/context/authentication.context";

interface CustomerApplicationsTableProps {
    applications: IPageResponse<CustomerApplication> | null;
    onPageChange: (page: number) => void;
    isRequesting: boolean;
    onCancel: (id: number) => void;
    onUpdate: (application: CustomerApplication) => void;
}

export function CustomerApplicationsTable(props: CustomerApplicationsTableProps) {
    const { hasPermission } = useAuthContext();
    
    const applications: Array<CustomerApplication> | null = props.applications ? props.applications.content : null;
    const pageResponse = props.applications;
    
    if (!applications || !pageResponse) return <></>;

    const isWebAdmin = hasPermission(CustomerPermission.WEB_ADMIN);

    const customerCardsTableRows = applications.map((application: CustomerApplication) => {
        const cardCount = application.customerApplicationCards?.map(card => card.cardsCount).reduce((acc, curr) => acc + curr, 0) ?? 0;

        return (
            <tr key={'row-' + application.id}>
                <td>
                    #{ application.id }
                </td>
                <td>
                    { application.createdDate }
                </td>
                <td>
                    { CUSTOMER_APPLICATION_TYPE_MAP[application.applicationType] }
                </td>
                <td>
                    { application.purchaseVolume ?? '-' }
                </td>
                <td>
                    { cardCount === 0 ? '-' : cardCount }
                </td>
                <td>
                    { CUSTOMER_APPLICATION_STATUS_MAP[application.status] }
                </td>
                <td>
                    { application.contact?.name }
                </td>
                {
                    isWebAdmin && (
                        <td>
                            {
                                application.status === CustomerApplicationStatus.PENDING && (
                                    <div className="row__actions">
                                        <div className='icon__edit action-icon' onClick={() => props.onUpdate(application)} />
                                        <div className='icon__cancel action-icon' onClick={() => props.onCancel(application?.id)} />
                                    </div>
                                )
                            }
                        </td>
                    )
                }
            </tr>
        )
    });
    return (
        <div className="table__container scroll-icon-md">
            <table className='customer-applications__table table table-responsive-md table-hover'>
                <thead>
                    <tr>
                        <th>Nr</th>
                        <th>Kuupäev</th>
                        <th>Tüüp</th>
                        <th>Kuumaht (liitrid/ kwh)</th>
                        <th>Kaartide arv</th>
                        <th>Staatus</th>
                        <th className="text-left">Kontakt</th>
                        { isWebAdmin && <th>Tegevused</th> }
                    </tr>
                </thead>
                <tbody>
                {props.isRequesting ?
                <tr>
                    <td colSpan={7}>
                        <div className="p-4 w-100 d-flex align-items-center justify-content-center">
                            <Spinner animation="grow" />
                        </div>
                    </td>
                </tr> :
                customerCardsTableRows}                    
                </tbody>
                <tfoot>
                    {pageResponse ? <tr>
                        <td colSpan={7}>
                            <div className="pagination-wrapper">
                                <Pagination
                                    locale={locale}
                                    current={pageResponse.number + 1}
                                    total={pageResponse.totalElements}
                                    pageSize={pageResponse.size}
                                    prefixCls={"pagination"}
                                    onChange={props.onPageChange}
                                    showSizeChanger={false}
                                    hideOnSinglePage={true}
                                />
                            </div>
                        </td>
                    </tr> : null}
                </tfoot>
            </table>
        </div>
    )
}